<template>
  <div>
      <div class="d-flex justify-content-between">
            <h1 class="page-header">
                {{ $t('newsCategory.pageTitle') }}
            </h1>
            <ts-breadcrumb :items="[
                {   text : $t('home'),href: '/'},
                {
                    text : $t('newsCategory.pageTitle'),
                    active : true
                }
            ]"/>
        </div>
    <ts-panel>
      <ts-panel-wrapper class="ts-flex ts-items-center ts-justify-between">
        <Button type="info" ghost @click="addNew">{{
            $t('addNew')
        }}</Button>
        <div class="ts-justify-end ts-space-x-2">
          <Input search v-model="search" :placeholder="$t('newsCategory.search')" :style="width"
            @on-focus="() => (width = 'width: 500px')" @on-blur="() => (width = 'width: 300px')" />
        </div>
      </ts-panel-wrapper>
      <Table :columns="columns" :data="resources" size="small" :loading="loading" max-height="700"  highlight-row stripe >
        <template slot-scope="{ row }" slot="action">
          <a href="#" class="text-primary" @click.prevent="onEdit(row)" v-tooltip="$t('edit')">
            <Icon type="ios-create" size="20" />
          </a>
          <Poptip confirm :title="$t('areYouSure')" @on-ok="onDelete(row)" :transfer="true" :ok-text="$t('yes')"
            :cancel-text="$t('no')">
            <a class="text-danger" v-tooltip="$t('delete')" :disabled="row._deleting">
              <i class="fas fa-circle-notch fa-spin" v-if="row._deleting"></i>
              <Icon type="ios-trash" size="20" v-else />
            </a>
          </Poptip>
        </template>
      </Table>
      <div class="ts-flex ts-items-center ts-justify-end ts-p-4">
        <ts-i-pagination v-model="pagination" @navigate="fetchData"></ts-i-pagination>
      </div>

      <!-- form-action -->
      <a-modal v-model="showForm" v-if="showForm" draggable sticky scrollable :mask="false" :footer="null"
        :z-index="1022" :title="$t('newsCategory.pageTitle')">
        <from-action ref="form_action" @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-panel>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

import Vue from 'vue'
import ViewUI from 'view-design'
import locale from 'view-design/dist/locale/en-US'
Vue.use(ViewUI, { locale })
Vue.use(ViewUI)

export default {
  name: 'news-CategoryIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false,
      width: 'width: 300px',
    }
  },
  created() {
    this.fetchData();  
  },
  computed: {
    ...mapState('website/newsCategory', ['resources', 'pagination']),
   
    search: {
      get() {
        return this.$store.state.website.newsCategory.search
      },
      set(newValue) {
        this.$store.commit('website/newsCategory/SET_SEARCH', newValue)
        this.$store.commit('website/newsCategory/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          title: this.$t('newsCategory.newsCategoryName'),
          key: 'category_name',
          minWidth: 200
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          className: 'ts-space-x-2',
          width: 85
        }
      ]
    }
  },
  methods: {

    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('website/newsCategory/fetch', {
          ...attributes
        })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.notice({ type: 'error', text: error.message })
        })
    },
     onEdit(row) {
      this.$store.commit('website/newsCategory/SET_EDIT_DATA', row)
      this.showForm = true
    },
    clearEdit() {
      this.showForm = false
      this.$store.commit('website/newsCategory/SET_EDIT_DATA', {})
    },
    addNew() {
      this.$store.commit('website/newsCategory/SET_EDIT_DATA', {})
      this.showForm = true
    },
    async onDelete(row) {
      row._deleting = true
      this.$store
        .dispatch('website/newsCategory/destroy', row.news_category_id)
        .then(response => {
          this.fetchData()
          row._deleting = false
          this.notice({
            type: response.message_id == 0 ? 'success' : 'warning',
            text: response.message
          })
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
          row._deleting = false
        })
    },
    notice(not) {
      this.$Notice[not.type]({
        title: 'NEWS CATEGORY',
        desc: not.text
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },

}
</script>
